<template>
  <ClientAvatarAndName
    :name="owner.data?.name"
    :logo="domainBranding.data?.avatar?.signedUrl"
    :accent-color="domainBranding.data?.accentColor"
  />
</template>

<script setup lang="ts">
import type { Ref } from 'vue';
import { onMounted, ref, toRefs } from 'vue';

import {
  DomainBranding,
  DomainReference,
  Loadable,
} from '@rygen/rygen-ui/model';

import { useDomainStore } from '@/stores/Domain';

import ClientAvatarAndName from '@/components/client/ClientAvatarAndName.vue';

const props = defineProps({
  domainId: {
    type: Number,
    default: () => undefined,
  },
});
const { domainId } = toRefs(props);

const { loadDomain, loadDomainBranding } = useDomainStore();

const owner: Ref<Loadable<DomainReference>> = ref({ loading: false });
const domainBranding: Ref<Loadable<DomainBranding>> = ref({
  loading: false,
});

onMounted(async () => {
  if (domainId?.value) {
    owner.value = await loadDomain(domainId.value);
    domainBranding.value = await loadDomainBranding(domainId.value);
  }
});
</script>
